const termsOfUseText = `


### Racklet AI - Terms of Use Agreement
#### Effective Date: 3/4/2025

1. Acceptance of Terms
By registering for and using Racklet AI (“the Application”), you (“User”) agree to comply with these Terms of Use. If you do not agree, you must not use the Application.

2. Permitted Use
Racklet AI is designed to provide AI-powered tools and services for lawful and ethical use. You agree to use the Application only for its intended purposes and in accordance with all applicable laws and regulations.

3. Prohibited Activities
Users must not use Racklet AI to: Engage in any illegal, fraudulent, or deceptive activities.
Generate, distribute, or promote harmful, abusive, harassing, or discriminatory content.
Violate any laws, regulations, or the rights of others.
Attempt to reverse-engineer, exploit, or manipulate the Application’s AI technology.
Use the AI for self-harm, harm to others, or any malicious intent.
4. Account Termination and Legal Action
Racklet AI reserves the right to immediately suspend or terminate accounts found violating these Terms. Evidence of misuse may also result in legal action.

5. No Warranty & Limitation of Liability
Racklet AI is provided "as is" without warranties of any kind. Racklet AI is not responsible for any consequences arising from misuse of the Application. Users assume full responsibility for their actions.

6. Changes to the Terms
Racklet AI may update these Terms at any time. Continued use of the Application after changes means you accept the new Terms.

7. Contact Information
For questions regarding these Terms, contact us at: [Insert Contact Email]

By using Racklet AI, you acknowledge and agree to these Terms of Use.
`;

export default termsOfUseText;
